import React from 'react'
import { useState, useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PageNotFound from './PageNotFound';

function BlogDetail() {
const [data, setData] = useState([])
const {slug} = useParams();

const canonical = "https://www.indianarmour.com/"+ slug;
const facebook = "https://www.facebook.com/sharer/sharer.php?u="+ slug;

const location = useLocation();
const slug1 = location.pathname.split("/")[1];

const ImageURL = 'https://www.indianarmour.com/indianarmourcms/';

// ✅ Removes organization schema on all blog detail pages
useEffect(() => {
  const script = document.getElementById('organization-schema');
  if (script) script.remove();

  return () => {
    // Restores schema when user navigates away from blog detail
    if (!document.getElementById('organization-schema')) {
      const s = document.createElement('script');
      s.id = 'organization-schema';
      s.type = 'application/ld+json';
      s.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Indian Armour",
        "alternateName": "Indian Armour",
        "url": "https://www.indianarmour.com/",
        "logo": "https://www.indianarmour.com/images/logo.svg",
        "sameAs": [
          "https://www.facebook.com/indianarmoursystems/",
          "https://twitter.com/armour_indian",
          "https://www.instagram.com/indian_armour_systems/",
          "https://www.youtube.com/channel/UCXTbVLwSlwaSKsQoRV2E1RA",
          "https://www.linkedin.com/in/indian-armour-5b60a6188/"
        ]
      });
      document.head.appendChild(s);
    }
  };
}, []);

// Existing API call
useEffect(() => {
  fetch(`https://www.indianarmour.com/indianarmourcms/APIs/Blog/blogdetail.php?slug=${slug1}`)
    .then((res) => res.json())
    .then((data) => {
      setData(data);
      console.log(data[0].title)
    })
    .catch((err) => {
      console.log(err);
    });
}, []);

return (
  <div>
    <Helmet>
      <link rel="canonical" href={canonical} />
      <title>{data?.[0]?.meta_title}</title>
      <meta
        name="description"
        content={data?.[0]?.meta_desc}
      />
      {data?.[0]?.schema_content && (
        <script type="application/ld+json">
          {data[0].schema_content}
        </script>
      )}
    </Helmet>

    {data[0]?.Status=="True" ?
      <div>
        <section className="inner-banner d-flex align-items-center justify-content-center" style={{backgroundImage: 'url("../images/blog-banner.jpg")'}}>
          <div className="inner-banner-content1">
            <div className="container">
              <h1 className="text-white fw-bolder">Blogs</h1>
            </div>
          </div>
        </section>

        <section className="breadcrumb-inner pt-3 pb-5">
          <div className="container">
            <nav>
              <ol className="breadcrumb mb-0 justify-content-start">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/blog">Blog</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {data[0]?.title}
                </li>
              </ol>
            </nav>
          </div>
        </section>

        <section className="blog-detail-blk pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <p><span className="blog-detail-date">{data[0]?.publish_date}</span></p>
                <h2>{data[0]?.title}</h2>
                <div className="blog-detail-img">
                  <img src={ImageURL + data[0]?.image} className="img-fluid w-100" />
                </div>
                <p dangerouslySetInnerHTML={{__html: data[0]?.content}}></p>
              </div>
              {data[0]?.posted_by &&
                <p><span className="blog-detail-date">Posted By- {data[0]?.posted_by}</span></p>
              }
               {data[0]?.faq?.length > 0 &&
          <section className='blg-faq faq  pb-50'>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                    <div className="accordion" id="accordionExample2">
                        {data[0].faq.map((item, index) => (
                          <div className="accordion-item" key={index}>
                            <h2 className="accordion-header" id={`faqHeading${index}`}>
                              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#faqCollapse${index}`} aria-expanded="false" aria-controls={`faqCollapse${index}`}>
                              {item.question}
                              </button>
                            </h2>
                            <div id={`faqCollapse${index}`} className="accordion-collapse collapse" aria-labelledby={`faqHeading${index}`} data-bs-parent="#accordionExample2">
                              <div className="accordion-body" dangerouslySetInnerHTML={{ __html: item.answer }}>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                  </div>
                </div>
            </div>
          </section>
        }
              <div className='share'>Share:
                {<Link to={`http://www.linkedin.com/shareArticle?mini=true&url=${canonical}`} target='_blank'> <i class="fa-brands fa-linkedin fa-xl" title="Linkedin"></i> </Link>}
                <Link to={`https://www.facebook.com/sharer/sharer.php?u=${canonical}&title=${data[0]?.title}`} target='_blank'> <i class="fa-brands fa-facebook fa-xl" title="Facebook"></i> </Link>
                <Link to={`https://twitter.com/intent/tweet?text=${data[0]?.title}...'+${canonical}`} target='_blank'> <i class="fa-brands fa-twitter fa-xl" title="Twitter"></i> </Link>
              </div>
              <Link to='/blog' className="back"><i className="fa-solid fa-arrow-left-long" /> Back </Link>
            </div>
          </div>
        </section>

       
      </div>


    : "" }

    {data[0]?.Status=="False" ? <PageNotFound/> : ""}

  </div>
)

}

export default BlogDetail